import React from 'react';
// I moduli sono ora integrati direttamente in SolutionIntro come parte
// della Delivery Experience, organizzati per fase del journey.
export function Modules() {
  return null;
}